import * as React from 'react'

export const ExternalProductLink = ({ children, href }: { children?: React.ReactNode; href: string }): JSX.Element => (
  <div>
    <a href={href} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  </div>
)
